import { create } from "zustand";
import { SPLIT_VIEW_TYPE } from "../configs/constants/SplitViewType";

interface SplitViewStore {
	showSplitView: boolean;
	activeSidebar: SPLIT_VIEW_TYPE;

	/**
	 * Id of the time report shown in the details split view. UI state only —
	 * the sidebar fetches the actual report via React Query (useTimeReport).
	 */
	activeTimeReportId?: string;

	setActiveTimeReportId(timeReportId?: string): void;
	toggleSplitView(): void;
	setActiveSplitView(splitView: SPLIT_VIEW_TYPE): void;
	hideSplitView(): void;
}

export const useSplitViewStore = create<SplitViewStore>()((set) => ({
	showSplitView: false,
	activeSidebar: SPLIT_VIEW_TYPE.TIME_REPORT_DETAILS,
	activeTimeReportId: undefined,

	setActiveTimeReportId(timeReportId) {
		set({ activeTimeReportId: timeReportId });
	},

	toggleSplitView() {
		set((state) => ({ showSplitView: !state.showSplitView }));
	},

	setActiveSplitView(splitView) {
		set({ activeSidebar: splitView });
	},

	hideSplitView() {
		set({ showSplitView: false });
	},
}));
